export function isEmailSimple(str) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(str).trim());
}